import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import SideBar from "../components/my-account/sidebar";
import { Helmet } from "react-helmet-async";
const MyAccount = () => {
  return (
    <>
      <Helmet>
        <title>My Account | WeRentt</title>
        <meta
          name="description"
          content="Update your account details and preferences in your SoWeRent Technology LLP profile."
        />
        <link rel="canonical" href="https://www.werentt.com/my-account" />
      </Helmet>
      <section className="section-padding my-account-section">
        <Container className="booking-container">
          <Row>
            <Col lg={3}>
              <SideBar />
            </Col>
            <Col lg="9">
              <div className="account-card">
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MyAccount;
